module.exports = __webpack_public_path__ + "img/image3.6a320e64.png";